/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "Ngày",
    value5: "",
    spendId: "25",
    index: "I",
    title: "Số ngày khai thác dầu khí trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: " ",
    value5: "",
    index: "II",
    title: "Sản lượng",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "26",
    index: "1",
    title: "Sản lượng dầu khí chịu thuế tài nguyên kỳ tính thuế trước chuyển sang",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "27",
    index: "2",
    title: "Sản lượng dầu khí chịu tthuees tài nguyên trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "28",
    index: "3",
    title: "Sản lượng dầu khí chịu thuế tài nguyên thực tế bán trong kỳ tính thuế [28]=[28a]+[28b]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "28a",
    index: "3.1",
    title: "- Xuất khẩu",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "28b",
    index: "3.2",
    title: "- Tiêu thụ nội địa",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "29",
    index: "4",
    title:
      "Sản lượng dầu khí chịu thuế tài nguyên chuyển sang kỳ tính thuế sau [29]=[26]+[27]+[28]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "30",
    index: "5",
    title:
      "Sản lượng dầu khí chịu thuế tài nguyên bình quân/ngày trong kỳ tính thuế [30]=[27]/[25]",
  },
  {
    id: uuidV4(),
    value4: "VND",
    value5: "",
    spendId: "31",
    index: "III",
    title: "Tổng doanh thu xuất bán trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "%",
    value5: "",
    spendId: "32",
    index: "IV",
    title: "Tỷ lệ thuế tài nguyên bằng dầu khí trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: " ",
    value5: "",
    spendId: "",
    index: "V",
    title: "Thuế tài nguyên tính bằng dầu khí",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "33",
    index: "1",
    title: "Thuế tài nguyên bằng dầu khí chưa bán kỳ tính thuế trước chuyển sang",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "34",
    index: "2",
    title: "Thuế tài nguyên bằng dầu khí phải nộp trong kỳ tính thuế [34]=[27]x[32]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "35",
    index: "3",
    title: "Thuế tài nguyên bằng dầu khí bán trong kỳ tính thuế [35]=[33]+([28]-[26])x[32]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "36",
    index: "4",
    title: "Thuế tài nguyên bằng dầu khí chưa bán chuyển sang kỳ tính thuế sau [36]=[33]+[34]-[35]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "37",
    index: "VI",
    title: "Giá tính thuế tài nguyên trong kỳ tính thuế [37]=[31]/[28]",
  },
  {
    id: uuidV4(),
    value4: "VND",
    value5: "",
    spendId: "38",
    index: "VII",
    title: "Số tiền thuế tài nguyên phải nộp trong kỳ tính thuế [38]=[39]+[40]",
  },
  {
    id: uuidV4(),
    value4: "VND",
    value5: "",
    spendId: "39",
    index: "1",
    title: "Số tiền thuế tài nguyên kỳ trước chuyển sang [39]=[33]x[37]",
  },
  {
    id: uuidV4(),
    value4: "VND",
    value5: "",
    spendId: "40",
    index: "2",
    title: "Số tiền thuế tài nguyên phát sinh trong kỳ tính thuế [40]=([35]-[33])x[37]",
  },
  {
    id: uuidV4(),
    value4: "VND",
    value5: "",
    spendId: "41",
    index: "VIII",
    title: "Số tiền thuế tài nguyên tạm tính đã kê khai trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "VND",
    value5: "",
    spendId: "42",
    index: "IX",
    title:
      "Chênh lệch giữa số tiền phải nộp theo quyết toán với số đã kê khai trong kỳ tính thuế [42]=[38]-[41]",
  },
  {
    id: uuidV4(),
    value4: "VND/USD",
    value5: "",
    spendId: "43",
    index: "X",
    title: "Tỷ giá quy đổi",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (spendId) =>
    ["28", "29", "30", "34", "35", "36", "37", "38", "39", "40", "42"].includes(spendId) ||
    !spendId;

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị tính
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Số tiền
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.spendId ? `[${item.spendId}]` : ""}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value4 ? (
                    item.value4
                  ) : (
                    <select
                      style={selectStyle}
                      // onChange={(e) =>
                      //   handleChange({ id: item.id, value: e.target.value, name: "value4" })
                      // }
                    >
                      <option value="1">Thùng</option>
                      <option value="2">m3</option>
                    </select>
                  )}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value5}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
